// Returns true if the numbers are approximately equal to each other, and false
// otherwise. This turns out to be shockingly hard to get right! I'd encourage
// you to read the following post to learn more:
//
// https://randomascii.wordpress.com/2012/02/25/comparing-floating-point-numbers-2012-edition/
//
// We're using the solution with the following rave review:
//
//     This function is not bad. It works. Mostly.
//
// because it's way easier to implement in javascript, and is probably close
// enough for our purposes.
export function numbersApproximatelyEqual(a: number, b: number): boolean {
  const diff = Math.abs(a - b);
  const largest = Math.max(Math.abs(a), Math.abs(b));
  return diff <= largest * Number.EPSILON;
}
